export default () => ({
    usuarios: []
})